import styled, { css } from 'styled-components';
import { ListVariant } from '../../_shared/types/trade';
import Page from '../../_shared/components/Page';
import Button from '../../_shared/components/Button';

const listViewPageStyles = css`
  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH};
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    overflow: visible;
    max-width: ${({ theme }) => theme.BP.VDP_DESKTOP_WL};
  }
`;

const gridViewPageStyles = css`
  max-width: 1279px;
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    max-width: 1545px;
  }
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WH}) {
    max-width: 1786px;
  }
`;

export const StyledPage = styled(Page)`
  ${props => props.variant === ListVariant.LIST && listViewPageStyles}
  ${props => props.variant === ListVariant.GRID && gridViewPageStyles}
`;

const listViewStyles = css`
  display: grid;
  grid-column-gap: 24px;
  grid-template-columns: 240px auto;
`;

const gridViewStyles = css`
  display: grid;
  grid-column-gap: 26px;
  grid-template-columns: 711px 542px;
  grid-template-rows: 177px auto;

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    grid-template-columns: 240px 711px 516px;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WH}) {
    grid-template-columns: 240px 952px 516px;
  }
`;

const containerStyles = css`
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
`;

export const StyledTradesContainer = styled.div`
  padding: 30px 0px;
  ${containerStyles}
  ${({ variant }) => variant === ListVariant.LIST && listViewStyles}
  ${({ variant }) => variant === ListVariant.GRID && gridViewStyles}
`;

const listViewHeader = css`
  grid-column: 1 / span 2;
`;

const gridViewHeader = css`
  grid-column: 1;
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    grid-column: 2;
  }
`;

export const StyledHeader = styled.div`
  ${({ variant }) => variant === ListVariant.LIST && listViewHeader}
  ${({ variant }) => variant === ListVariant.GRID && gridViewHeader}
`;

const listViewTradeGrid = css`
  grid-column: 2;
  grid-row: 2;
`;

const gridViewTradeGrid = css`
  grid-column: 1;
  grid-row: 2;
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    grid-column: 2;
  }
`;

export const StyledTradeGridContainer = styled.div`
  ${({ variant }) => variant === ListVariant.LIST && listViewTradeGrid}
  ${({ variant }) =>
    variant === ListVariant.GRID && gridViewTradeGrid}
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledFilterIndicator = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  color: ${({ theme }) => theme.FONT_WEIGHTS.BASE_INVERTED};
  padding-bottom: 12px;

  span:first-child {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  }
  span:nth-child(3) {
    font-style: italic;
  }
`;

export const StyledRefreshButton = styled(Button.Borderless)`
  color: ${({ theme }) => theme.COLORS.BASE};
  background: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledRefreshButtonContainer = styled.div`
  right: ${({ showButton }) => (showButton ? '24px' : '-500px')};
  transition: all 0.3s linear;
  padding: 5px 0px 5px 10px;
  border-radius: 5px;
  bottom: 24px;
  position: fixed;
  color: ${({ theme }) => theme.COLORS.BASE};
  background: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  z-index: 30;
`;
